import { useMemo } from 'react'

import { useRenderStatusStore } from 'src/hooks/stores/useRenderStatusStore'

export const useRenderStatus = () => {
  const { renderStatusStoreValue, setRenderStatusStoreValue } = useRenderStatusStore()

  /** 住戸ページに必要なコンポーネントがレンダリングされている場合true */
  const isRoomsPageContentReady = useMemo(() => {
    // NOTE: グローバルナビゲーション、住戸テーブル、住戸ページヘッダーが全てレンダリングされている場合、住戸ページのコンテンツが全て揃っていると判断する
    return (
      renderStatusStoreValue.isRenderGlobalNavigation &&
      renderStatusStoreValue.isRenderRoomTable &&
      renderStatusStoreValue.isRenderRoomPageHeader
    )
  }, [renderStatusStoreValue])

  const updateGlobalNavigationRenderStatus = (status: boolean) => {
    setRenderStatusStoreValue(previous => ({
      ...previous,
      isRenderGlobalNavigation: status,
    }))
  }

  const updateRoomTableRenderStatus = (status: boolean) => {
    setRenderStatusStoreValue(previous => ({
      ...previous,
      isRenderRoomTable: status,
    }))
  }

  const updateRoomPageHeaderRenderStatus = (status: boolean) => {
    setRenderStatusStoreValue(previous => ({
      ...previous,
      isRenderRoomPageHeader: status,
    }))
  }

  return {
    isRoomsPageContentReady,
    updateGlobalNavigationRenderStatus,
    updateRoomTableRenderStatus,
    updateRoomPageHeaderRenderStatus,
  }
}
